import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EventService {

  private listeners = [];

  private lastFn = [];
  private debounceTime = 200;

  constructor() { }

  emit(name: string, ...data) {
    this.listeners.forEach(listener => {
      if (listener.name === name && listener.fn) {
        listener.fn(...data);
      }
    });
  }

  on(uniqueName: string, name: string | string[], fn) {
    let newIndexes = [];
    if (Array.isArray(name)) {
      newIndexes = name.map(N => this.add(uniqueName, N, fn));
    } else {
      newIndexes.push(this.add(uniqueName, name, fn));
    }
    return () => {
      this.listeners = this.listeners.filter((_, i) => !newIndexes.includes(i));
    };
  }

  private add(uniqueName, name, fn) {
    const listener = this.listeners.find(L => L.uniqueName === uniqueName && L.name === name);
    if (listener) {
      listener.fn = fn;
    } else {
      this.listeners.push({ uniqueName, name, fn });
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/services/event/event.service.ts